<template>
  <div class="layout-content">
    <img src="../../assets/home/hxzl.jpg" width="100%" height="2405px">
    <span  class="for-record">
      © {{ new Date().getFullYear() }} 浙江萧山化学纤维产业大脑有限公司版权所有&nbsp;&nbsp;v<font>{{version}}</font> &nbsp;&nbsp; </br>备案号：<a href="http://beian.miit.gov.cn/" target="_blank"> {{ recordicp }} </a><img
      src="../../assets/home/ba.png" height="22" width="20" style="vertical-align: sub; margin-left: 12px"/><a :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode='+recordpublic" rel="noopener" target="_blank"> 公网备案：{{ recordpublic }}</a>
      </span>
  </div>

</template>

<script>
export default {
  name: "propaganda-hxzl",
  data () {
    return {
      version:this.$versionclient,
      recordicp:process.env.RECORD=='production'?'浙ICP备2022025995号':'浙ICP备2022025995号-2',
      recordpublic:process.env.RECORD=='production'?'33010902003449':'33010902003449'
    }
  }
}
</script>

<style scoped>
.layout-content{
  width: 100%;
  background: #003BB5;
  overflow: auto;
  height: 100%;
  position: relative;
}
.for-record{
  display: block;
  background: #000;
  line-height: 160%;
  padding: 18px 0;
  font-size: 14px;
  color: #fff;
  width: 100%;
  text-align: center;
}
.for-record a{
  color: #fff;
}
.for-record a:hover{
  color: blue;
}
</style>



// WEBPACK FOOTER //
// src/views/secondary/propaganda-hxzl.vue